import { render, staticRenderFns } from "./VehiculesSlider.vue?vue&type=template&id=139b3b06&scoped=true&"
import script from "./VehiculesSlider.vue?vue&type=script&lang=js&"
export * from "./VehiculesSlider.vue?vue&type=script&lang=js&"
import style0 from "./VehiculesSlider.vue?vue&type=style&index=0&id=139b3b06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b3b06",
  null
  
)

export default component.exports